import { Typography } from '@sweep-io/sweep-design';
import { ConfirmDialog } from '../../../common/dialogs/ConfirmDialog';

export const SectionDeleteConfirmationDialog = ({
  closeDialog,
  onConfirm,
}: {
  closeDialog: () => void;
  onConfirm: () => void;
}) => {
  return (
    <ConfirmDialog
      title="Delete Section"
      confirmText="Delete"
      cancelText="Cancel"
      isOpen
      onConfirm={onConfirm}
      onCancel={closeDialog}
      confirmButtonType="error"
    >
      <Typography variant="body">The elements inside will be removed as well</Typography>
    </ConfirmDialog>
  );
};
